import React from "react";

/**
 * Compact “Show *n* entries” control for placing next to a page title (or anywhere outside {@link ./AdminServerList.jsx}).
 *
 * @param {number} props.value
 * @param {(n: number) => void} props.onChange
 * @param {number[]} [props.options]
 * @param {string} [props.className]
 * @param {string} [props.ariaLabel]
 */
const DataTablePageSize = ({
  value,
  onChange,
  options = [10, 25, 50, 100],
  className = "",
  ariaLabel = "Rows per page"
}) => (
  <label className={`admin-dt-page-size ${className}`.trim()}>
    <span>Show</span>
    <select value={value} onChange={(e) => onChange(Number(e.target.value))} aria-label={ariaLabel}>
      {options.map((n) => (
        <option key={n} value={n}>
          {n}
        </option>
      ))}
    </select>
    <span>entries</span>
  </label>
);

export default DataTablePageSize;
